import * as yup from "yup";

const spaceCheckYupValidation = (val?: string) => val ? (!/^\s*$/.test(val)) : false

export const AddPracticeSchema = yup.object({
  npi: yup
    .string()
    .required(`NPI is required`)
    .test("containAllDigits", "NPI should only contain digits", (val) => val ? (/^\d+$/.test(val)) : false)
    .min(10, `NPI Invalid`)
    .max(10, `NPI Invalid`),
  name: yup
    .string()
    .required(`Practice Name is required`)
    .max(120, `Practice Name should only be 120 characters long`)
    .test("whiteSpaceRemoval", "Practice name should not contain only spaces", (val) => spaceCheckYupValidation(val)),
  soc_type: yup.string().required(`SoC type is required`),
  office_contact: yup
    .string(),
  tax_id: yup
    .string()
    .max(9, `Tax id Invalid`),
  phone_number: yup
    .string()
    .required(`Phone Number is required`)
    .min(10, `Phone Number Invalid`)
    .max(10, `Phone Number Invalid`)
    .test('range', 'Phone Number Invalid', (val) => {
      const numberedVal = Number(val)
      if (!isNaN(numberedVal)) {
        if (numberedVal > 2000000000 && numberedVal < 9999999999) return true;
      }
      return false;
    }),
  fax_number: yup
    .string()
    .required(`Fax Number is required`)
    .min(10, `Fax Number Invalid`)
    .max(10, `Fax Number Invalid`)
    .test('range', 'Fax Number Invalid', (val) => {
      const numberedVal = Number(val)
      if (!isNaN(numberedVal)) {
        if (numberedVal > 2000000000 && numberedVal < 9999999999) return true;
      }
      return false;
    }),

  address: yup.object({
    street: yup
      .string()
      .required(`Street is required`)
      .max(255, 'Street should not be longer than 255 characters')
      .test("whiteSpaceRemoval", "Street should not contain only spaces", (val) => spaceCheckYupValidation(val)),
    suite: yup
      .string()
      .max(255, 'Suite should not be longer than 255 characters')
      .when({
        is: (val?: string) => val && val.length > 0,
        then: (schema) =>
          schema
            .test("whiteSpaceRemoval", "Suite should not contain only spaces", (val) => spaceCheckYupValidation(val)),
      }),
    city: yup
      .string()
      .required(`City is required`)
      .max(255, 'City should not be longer than 255 characters'),
    state: yup
      .string()
      .required(`State is required`),
    zip: yup
      .string()
      .required(`Zip code is required`)
      .max(10, `Zip code Invalid`)
      .test("containAllDigits", "Zip code should only contain digits", (val) => val ? (/^\d+$/.test(val)) : false),
    timezone: yup.string().required('Timezone is required'),
  }),
});
